import {Action} from "@ngrx/store";
import {IAccount, IAccountOperation} from "../../models/accounting/accounting.interface";

export enum EAccountingActions {
  GetAccounts = '[Accounting] Get Accounts',
  GetAccountsSuccess = '[Accounting] Get Accounts Success',
  GetAccountsFailure = '[Accounting] Get Accounts Failure'

}
export class GetAccounts implements Action {
  public readonly type = EAccountingActions.GetAccounts;
}
export class GetAccountsSuccess implements Action {
  public readonly type = EAccountingActions.GetAccountsSuccess;
  constructor(public payload: Array<IAccount>){}
}
export class GetAccountsFailure implements Action {
  public readonly type = EAccountingActions.GetAccountsFailure;
}




export type AccountingActions =
  GetAccounts |
  GetAccountsSuccess |
  GetAccountsFailure;
